import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import {
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Slider,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import PlayerCardRow from "../PlayerCardRow";

const teamColors: { [id: string]: string[] } = {
  TBR: ["#02285C", "#90BDE7", "#FFFFFF"],
  BAL: ["#F25D23", "#000000", "#FFFFFF"],
  NYY: ["#132448", "#FFFFFF", "#FFFFFF"],
  BOS: ["#BD3039", "#0D2B56", "#FFFFFF"],
  TOR: ["#134A8E", "#E8291C", "#FFFFFF"],
  CLE: ["#E31937", "#002B5C", "#FFFFFF"],
  KCR: ["#004687", "#FFFFFF", "#FFFFFF"],
  DET: ["#0C2C56", "#FFFFFF", "#FFFFFF"],
  CHW: ["#000000", "#BFBFBF", "#FFFFFF"],
  MIN: ["#091F40", "#E31E34", "#FFFFFF"],
  HOU: ["#002D62", "#F4911E", "#FFFFFF"],
  SEA: ["#005C5C", "#0C2C56", "#FFFFFF"],
  TEX: ["#C0111F", "#003278", "#FFFFFF"],
  LAA: ["#BA0021", "#003263", "#C4CED4"],
  ATH: ["#00342C", "#FFB400", "#FFFFFF"],
  WSN: ["#AB0003", "#FFFFFF", "#FFFFFF"],
  NYM: ["#F75500", "#002C6E", "#FFFFFF"],
  MIA: ["#019CDB", "#E51829", "#FFFFFF"],
  PHI: ["#C21D39", "#01396F", "#FFFFFF"],
  ATL: ["#D3042B", "#001D3D", "#FFFFFF"],
  CIN: ["#C6011F", "#000000", "#FFFFFF"],
  PIT: ["#F7BF02", "#000000", "#FFFFFF"],
  CHC: ["#123581", "#E62F2E", "#FFFFFF"],
  MIL: ["#18294C", "#FEC430", "#FFFFFF"],
  STL: ["#BE0A15", "#FDDB00", "#FFFFFF"],
  LAD: ["#005A9D", "#FFFFFF", "#FFFFFF"],
  ARI: ["#C71128", "#00C2CE", "#FFFFFF"],
  SDP: ["#2D221C", "#FFC125", "#FFFFFF"],
  SFG: ["#231F20", "#F4793E", "#E8D8C4"],
  COL: ["#503E80", "#BFC2C9", "#FFFFFF"],
  FA: ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
  GDD: ["#F15C22", "#000000", "#FFFFFF"],
  MSS: ["#F4D12F", "#C80F2D", "#FFFFFF"],
  PEJ: ["#807E82", "#C1D72E", "#FFFFFF"],
  SRR: ["#008B98", "#B49A64", "#FFFFFF"],
  SCO: ["#C80F2D", "#000000ff", "#FFFFFF"],
  SUR: ["#49A942", "#BA0E2A", "#FFFFFF"],
  "0": ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
};

export default function STHitterPercentiles(props: any) {
  //console.log(props)
  const temp = Object.keys(props).includes('teamInfoProp')
  if (temp) {
    props.playerInfoProp.common = { teamInfo: props.teamInfoProp }
  }


  // Get team colors for styling
  const teamColor = props.playerDataProp.MLB_AbbName !== null
    ? teamColors[props.playerDataProp.MLB_AbbName][0]
    : teamColors["FA"][0];

  const textColor = props.playerDataProp.MLB_AbbName !== null
    ? teamColors[props.playerDataProp.MLB_AbbName][1]
    : teamColors["FA"][1];

  const [percentiles, setPercentiles] = useState<any>({});
  const [qualifier, setQualifier] = useState<string>("1");


  const handleQualifier = (event: SelectChangeEvent) => {
      setQualifier(event.target.value as string);
    };
    //console.log(season);
  
    const [ageRange, setAgeRange] = React.useState<number[]>([16, 45]);
  
    const handleAgeRange = (event: Event, newValue: any) => {
      setAgeRange(newValue);
    };

  useEffect(() => {
    fetch(
      props.prod
        ? "https://oriolebird.pythonanywhere.com/st/player_percentiles/" + props.id + '/P/' + props.season + '/'+qualifier+'/'+ageRange[0]+'/'+ageRange[1]
        : "/st/player_percentiles/" + props.id + '/P/' + props.season + '/'+qualifier+'/'+ageRange[0]+'/'+ageRange[1]
    )
      .then((res) => res.json())
      .then((data1) => {
        //console.log("P1 Full Response: ", data1);
        //console.log("P1 Data: ", data1.data[0]);
        //console.log("bat_speed value:", data1.data[0].bat_speed);
        setPercentiles(data1.data[0]);
      })

  }, [props.id, props.prod, props.season, qualifier, ageRange]);

  const handleSeason = (event: SelectChangeEvent) => {
    props.setSeason(event.target.value as string);
  };

  return (
    <div >
      <Grid
        container
        justifyContent="center"
        spacing={2}
      >
        <Grid maxWidth="90vw">
          <Box
            sx={{
              maxWidth: "90vw",
              width: "500px",
              border: "#293241 solid 2px",
              backgroundColor: "#FFFFFF",
              height: props.isDesktop ? "750px" : "100%",
              boxShadow:
                "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
            }}
            justifyContent="flex-start"
            alignItems="center"
            display="flex"
            flexDirection="column"
          >
            <div
              style={{
                width: "100%",
                paddingTop: "10px",
                paddingBottom: "10px",
                backgroundColor: teamColor,
              }}
            >
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <FormControl
                  variant="standard"
                  sx={{ paddingLeft: "15px", paddingTop: "0px", display: "flex", alignItems: "center" }}
                >
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={props.season}
                    label="Season"
                    onChange={handleSeason}
                    defaultValue="2024"
                    disableUnderline={true}
                    sx={{
                      height: "2.5rem",
                      color: textColor,
                      fontSize: props.isDesktop ? "18pt" : "14pt",
                      fontWeight: "bold",
                      "& .MuiSelect-root": {
                        borderColor: "white",
                        color: textColor,
                        borderBottom: "1px solid white",
                      },
                      "& .MuiSvgIcon-root": {
                        color: textColor,
                      },
                    }}
                  >
                    {props.seasons.map((s: any) => (
                      <MenuItem key={s} value={s}>{s}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Typography variant="h5" sx={{ margin: "0", display: "flex", alignItems: "center" }}>
                  <span
                    style={{
                      color: textColor,
                      fontWeight: "bold",
                      fontSize: "20pt",
                      textAlign: "center",
                    }}
                  >
                    Spring Training
                  </span>
                </Typography>
                <Typography variant="h5" sx={{ margin: "0", display: "flex", alignItems: "center" }}>
                  <span
                    style={{
                      color: textColor,
                      fontWeight: "bold",
                      fontSize: "20pt",
                      textAlign: "center"
                    }}
                  >
                    Pitching Percentiles
                  </span>
                </Typography>
              </Grid>
            </div>
            <div>
              <div
                style={{ margin: "auto", width: "475px", maxWidth: "90vw", marginTop: "10px" }}
              >
                <div
                  style={{ margin: "auto", maxWidth: "fit-content" }}
                >
                  <FormControl>
                    <InputLabel id="demo-simple-select-label">
                      PA Qualifier
                    </InputLabel>
                    <Select
                      value={qualifier}
                      label="PA Qualifier"
                      onChange={handleQualifier}
                      defaultValue="1"
                      sx={{ width: "102px" }}
                    >
                      <MenuItem value={1}>1</MenuItem>
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={30}>30</MenuItem>
                      <MenuItem value={40}>40</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                    </Select>
                  </FormControl>
                  <span
                    style={{
                      position: "absolute",
                      marginLeft: props.isDesktop ? "25px" : "15px",
                      marginTop: "3px",
                      color: "#5A6465",
                      fontSize: 16,
                    }}
                  >
                    Age Range
                  </span>
                  <Slider
                    getAriaLabel={() => "Age Range"}
                    value={ageRange}
                    onChange={handleAgeRange}
                    valueLabelDisplay="on"
                    min={16}
                    max={45}
                    disableSwap={true}
                    sx={{
                      width: "200px",
                      marginLeft: props.isDesktop ? "30px" : "20px",
                      marginTop: "25px",
                      "& .MuiSlider-valueLabel": {
                        fontSize: 11,
                        fontWeight: "bold",
                        marginTop: "33px",
                        backgroundColor: "unset",
                        color: "#FFFFFF",
                        "&::before": {
                          display: "none",
                        },
                        "& *": {
                          background: "transparent",
                          color: "#FFFFFF",
                        },
                      },
                    }}
                  />
                </div>
                <Typography
                  variant="h6"
                  sx={{
                    marginTop: "5px",
                    marginBottom: "5px",
                    color: "rgba(0, 0, 0, 0.4)",
                    fontWeight: 600,
                    fontSize: "0.5rem",
                    pointerEvents: "none",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    letterSpacing: "0.5em", // tweak this value until it fills ~80%
                  }}
                >
                  ProspectSavant.com/ST/player/{props.playerDataProp.id}
                </Typography>
                {percentiles.bat_speed !== undefined && <div>
                  <PlayerCardRow
                    stat="psStuff+"
                    value={percentiles.weighted_psStuff.toFixed(3)}
                    percentile={percentiles?.weighted_psStuff_p.toFixed(2) * 100}
                    percentile_raw={percentiles?.weighted_psStuff_p}
                    isDesktop={props.isDesktop}
                  />
                  <Divider variant="middle" />
                  <PlayerCardRow
                    stat="wOBA"
                    value={percentiles.woba.toFixed(3)}
                    percentile={percentiles?.woba_p.toFixed(2) * 100}
                    percentile_raw={percentiles?.woba_p}
                    isDesktop={props.isDesktop}
                  />
                  <Divider variant="middle" />
                  <PlayerCardRow
                    stat="Max Velo"
                    value={percentiles.max_velo.toFixed(1) + (props.isDesktop ? " mph" : "")}
                    percentile={percentiles?.maxvelo_p.toFixed(2) * 100}
                    percentile_raw={percentiles?.maxvelo_p}
                    isDesktop={props.isDesktop}
                  />
                  <Divider variant="middle" />
                  <PlayerCardRow
                    stat="EV"
                    value={percentiles.ev.toFixed(1) + (props.isDesktop ? " mph" : "")}
                    percentile={percentiles?.ev_p.toFixed(2) * 100}
                    percentile_raw={percentiles?.ev_p}
                    isDesktop={props.isDesktop}
                  />
                  <Divider variant="middle" />
                  <PlayerCardRow
                    stat="Barrel%"
                    value={(percentiles.barrelbbe).toFixed(1) + "%"}
                    percentile={percentiles?.barrelbbe_p.toFixed(2) * 100}
                    percentile_raw={percentiles?.barrelbbe_p}
                    isDesktop={props.isDesktop}
                  />
                  <Divider variant="middle" />
                  <PlayerCardRow
                    stat="Hard Hit%"
                    value={(percentiles.hhrate).toFixed(1) + "%"}
                    percentile={percentiles?.hhrate_p.toFixed(2) * 100}
                    percentile_raw={percentiles?.hhrate_p}
                    isDesktop={props.isDesktop}
                  />
                  <Divider variant="middle" />
                  <PlayerCardRow
                    stat="K%"
                    value={(percentiles.krate).toFixed(1) + "%"}
                    percentile={percentiles?.krate_p.toFixed(2) * 100}
                    percentile_raw={percentiles?.krate_p}
                    isDesktop={props.isDesktop}
                  />
                  <Divider variant="middle" />
                  <PlayerCardRow
                    stat="BB%"
                    value={(percentiles.bbrate).toFixed(1) + "%"}
                    percentile={percentiles?.bbrate_p.toFixed(2) * 100}
                    percentile_raw={percentiles?.bbrate_p}
                    isDesktop={props.isDesktop}
                  />
                  <Divider variant="middle" />
                  <PlayerCardRow
                    stat="Whiff%"
                    value={(percentiles.whiffrate).toFixed(1) + "%"}
                    percentile={percentiles?.whiffrate_p.toFixed(2) * 100}
                    percentile_raw={percentiles?.whiffrate_p}
                    isDesktop={props.isDesktop}
                  />
                  <Divider variant="middle" />
                  <PlayerCardRow
                    stat="Chase%"
                    value={(percentiles.chaserate).toFixed(1) + "%"}
                    percentile={percentiles?.chaserate_p.toFixed(2) * 100}
                    percentile_raw={percentiles?.chaserate_p}
                    isDesktop={props.isDesktop}
                  />
                  <Divider variant="middle" />
                  <PlayerCardRow
                    stat="ZSwing%"
                    value={(percentiles.zswing).toFixed(1) + "%"}
                    percentile={percentiles?.zswing_p.toFixed(2) * 100}
                    percentile_raw={percentiles?.zswing_p}
                    isDesktop={props.isDesktop}
                  />
                  <Divider variant="middle" />
                  <PlayerCardRow
                    stat="ZContact%"
                    value={(percentiles.zcontact).toFixed(1) + "%"}
                    percentile={percentiles?.zcontact_p.toFixed(2) * 100}
                    percentile_raw={percentiles?.zcontact_p}
                    isDesktop={props.isDesktop}
                  />
                  <Divider variant="middle" />
                  <PlayerCardRow
                    stat="SwStr%"
                    value={(percentiles.swstr).toFixed(1) + "%"}
                    percentile={percentiles?.swstr_p.toFixed(2) * 100}
                    percentile_raw={percentiles?.swstr_p}
                    isDesktop={props.isDesktop}
                  />
                </div>}
              </div>
            </div>

          </Box>
        </Grid>
      </Grid>
    </div >
  );
}